<template>
	<div class="pull-right">
	  <input type="number" style="max-width:100%" class="form-control col-md-6" :value="value" v-on:input="updateValue"> 
	</div>
</template>
<script>
export default {
  props: ['value', 'field' , 'row'],
  methods: {
    updateValue: function (e) {
      var val = e.target.value;
      if(val >= 0)
        this.row[this.field] = val;
    },
  },
}
</script>
